<unity-modal title="New Account" [hideFooter]="true" (onClose)="activeModal.close()" (keyup.enter)="$event.stopPropagation(); onInput()">
    <div #chatwindow class="chat-window">
        @if (chats?.length) {
            <div class="chats">
                @for (chat of chats; track chat.Id) {
                    <div class="chat" [ngClass]="{ 'request': chat.IsRequest }">
                        @if(chat.IsRequest) {
                            <div class="chat-request">
                                {{chat.RequestText}}
                            </div>
                        } @else {
                            <div class="chat-response">
                                <div>
                                    {{chat.ResponseBody.Exposition}}
                                </div>
                                @if (getCandidates(chat)?.length) {
                                    <div class="chat-response-table">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>CANDIDATE</th>
                                                    <th>CONTACT INFO</th>
                                                    <th class="table-last-column">
                                                        <button unity-button class="tertiary table-button" (onClick)="createNewAccount()">
                                                            Create New Account
                                                        </button>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                @for (candidate of getCandidates(chat); track candidate.AccountId) {
                                                    <tr>
                                                        <td>
                                                            <div>
                                                                <div class="d-flex">
                                                                    <div [innerHTML]="candidate.Name"></div> 
                                                                    @if(candidate.DBA) {
                                                                        &nbsp;(<div [innerHTML]="candidate.DBA"></div>)
                                                                    }
                                                                </div>
                                                                <div class="d-flex">
                                                                    @if (candidate.Address1) {
                                                                        <div [innerHTML]="candidate.Address1"></div>,&nbsp;
                                                                    }
                                                                    @if (candidate.Address2) {
                                                                        <div [innerHTML]="candidate.Address2"></div>,&nbsp;
                                                                    }
                                                                    @if (candidate.City) {
                                                                        <div [innerHTML]="candidate.City"></div>,&nbsp;
                                                                    }
                                                                    @if (candidate.State) {
                                                                        <div [innerHTML]="candidate.State"></div>&nbsp;
                                                                    }
                                                                    @if (candidate.PostalCode) {
                                                                        <div [innerHTML]="candidate.PostalCode"></div>
                                                                    }
                                                                </div>
                                                                <div>
                                                                    @if (candidate.County) {
                                                                        <div [innerHTML]="candidate.County + ' County'"></div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div [innerHTML]="'Phone: ' + candidate.Phone"></div>
                                                            @if (candidate.Website) {
                                                                <div [innerHTML]="candidate.Website"></div>
                                                            }
                                                            @if (candidate.FEIN?.includes("<strong>")) {
                                                                <div [innerHTML]="'FEIN: ' + candidate.FEIN"></div>
                                                            }
                                                        </td>
                                                        <td>
                                                            <div class="scoring-and-button">
                                                                <div>{{candidate.Confidence}}%</div>
                                                                <div>
                                                                    <button unity-button class="link small pe-1 table-button" (onClick)="goToAccount(candidate.AccountId)">
                                                                        Use This Account
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>      
                                } @else {
                                    <button unity-button class="tertiary" (onClick)="createNewAccount()">
                                        Create New Account
                                    </button>
                                }
                            </div>
                        }
                    </div>
                }

                @if (this.waitingForResponse) {
                    <div class="chat searching">
                        <div class="robot"><unity-icon icon="robot-face" size="xlarge"/></div>
                        <h4>Searching & Analyzing Account List...</h4>
                    </div>
                }
            </div>
        } @else {
            <div class="chat-zero">
                Let us check that your Account doesn't already exist by entering the 
                Account Information below by typing, uploading a document or telling us what it is...
            </div>
        }
    </div>
    <div class="chat-footer">
        <input class="form-control footer-input" [(ngModel)]="currentRequest" placeholder="Type Account Info..." />
        <input #fileInput type="file" style="display: none;" (change)="onFileSelected($event)" />
        <div class="footer-buttons">
            <button unity-button class="icon-only" (click)="fileInput.click()">
                <unity-icon icon="paperclip" />
            </button>
            <!-- <button unity-button class="icon-only"><unity-icon icon="megaphone" /></button> -->
            <button unity-button class="icon-only" (onClick)="onInput()" [disabled]="!currentRequest && !selectedFile"><unity-icon icon="send" /></button>
        </div>
    </div>
</unity-modal>
